import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { FluencyInLanguageConversationFormComponent } from "./fluency-in-language-conversation-form/fluency-in-language-conversation-form.component";
import { FluencyInLanguageConversationListComponent } from "./fluency-in-language-conversation-list/fluency-in-language-conversation-list.component";

const components = [FluencyInLanguageConversationFormComponent, FluencyInLanguageConversationListComponent];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule, SepidzGridModule],
})
export class FluencyInLanguageConversationModule {}
